import React from 'react';
import { Utensils, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * FoodLogCardWidget - Today's food logging status
 * Priority 5: Tracking (optional, lower urgency)
 */
export default function FoodLogCardWidget({ 
  entries = [],
  isToday = true,
  onNavigate 
}) {
  const mealsLogged = entries.length;
  const hasLogged = mealsLogged > 0;

  return (
    <button
      onClick={() => onNavigate && onNavigate('foodlog')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: hasLogged ? '#ECFDF5' : '#F3F4F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Utensils size={20} color={hasLogged ? '#059669' : ABLE_COLORS.textMuted} />
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          Food Log
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: hasLogged ? ABLE_COLORS.textSecondary : ABLE_COLORS.textMuted,
        }}>
          {!isToday ? "View history" :
           mealsLogged === 0 ? "Nothing logged yet" :
           mealsLogged === 1 ? "1 meal logged" :
           `${mealsLogged} meals logged`}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
